/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const MonospaceIcon = /*#__PURE__*/ createSvgIcon(
  'MonospaceIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M3.754 16a.734.734 0 01-.535-.215A.72.72 0 013 15.25V4.756c0-.212.071-.391.214-.537A.714.714 0 013.746 4c.21 0 .39.072.535.215a.72.72 0 01.219.535v10.494a.738.738 0 01-.214.537.714.714 0 01-.532.219zm12.5 0a.734.734 0 01-.535-.215.72.72 0 01-.219-.535V4.756c0-.212.072-.391.214-.537A.714.714 0 0116.246 4c.21 0 .39.072.535.215A.72.72 0 0117 4.75v10.494a.738.738 0 01-.214.537.714.714 0 01-.532.219zM7.23 14a.645.645 0 01-.552-.27.605.605 0 01-.073-.605L9.128 6.43a.677.677 0 01.247-.315A.65.65 0 019.752 6h.496c.14 0 .266.04.377.12.111.079.194.185.25.317l2.52 6.709a.637.637 0 01-.076.583c-.12.18-.29.271-.505.271a.697.697 0 01-.387-.115.565.565 0 01-.24-.322l-.558-1.605H8.396l-.563 1.625a.582.582 0 01-.229.302.647.647 0 01-.375.115zm1.583-3.208h2.396l-1.166-3.313h-.063l-1.166 3.313z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default MonospaceIcon;
